import { FC } from "react";
import { Pie } from "@ant-design/plots";

const DonutChart: FC<any> = (props) => {
  const data = props?.data;
  const config = {
    appendPadding: 10,
    data,
    angleField: "value",
    colorField: "type",
    radius: 0.8,
    innerRadius: 0.85,
    meta: {
      value:{
        formatter:(val:any)=> `${val}%`,
      }
    },
    label: {
      type: "inner",
      offset: "-50%",
      content: "",
      style: {
        textAlign: "center",
      },
      autoRotate: false,
      autoHide: true,
    }, 
    theme: {
      colors10: ["#833ce5", "#807af4", "#f1946f", "#807af4"],
    },
    statistic: undefined,
    tooltip: {
        domStyles:{
          "g2-tooltip": {backgroundColor:"#091e42", color:"#fff", borderRadius:"8px"}
        }
    },
    legend: {
      itemValue: {
        formatter: (title: any, item: any, index: number) => {
          return data[index]?.value + "%";
        },
        style: {
          fontWeight: 600,
          fontSize: 16,
          color: "#091e42",
        },
        alignRight: true,
      },

      maxWidthRatio: 5,
    },
  };
  return <Pie {...config} />;
};

export default DonutChart;
